import { store } from '@/redux/store';
import { User } from '@/types/models';
import { userSelector } from '@/redux/user/user.selectors';

export const getLoggedUser = (): User | undefined => {
  const userState = userSelector(store.getState());
  if (userState.loading === 'succeeded' && userState.userData) {
    return userState.userData;
  }
  return undefined;
};
